import axios from 'axios';

import { INTEL_API_URL } from '../constants/main';

const IntelService = {
  async uploadResumeFile(file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await axios.post(
      `${INTEL_API_URL}/resumetasks`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: onUploadProgress
          ? (progressEvent) => {
              const { loaded, total } = progressEvent;
              const percent = Math.floor((loaded * 100) / total);
              onUploadProgress(percent);
            }
          : undefined,
      }
    );
    return response.data;
  },

  async getResumeTaskStatus(id) {
    const response = await axios.get(`${INTEL_API_URL}/resumetasks/${id}`);
    return response.data;
  },

  async getResumeTaskResult(id) {
    const response = await axios.get(
      `${INTEL_API_URL}/resumetasks/${id}/output`
    );
    return response.data;
  },
};

export default IntelService;
